import { Helmet } from "react-helmet";
import AboutUsPageContent from "components/AboutUsPage/AboutUsPageContent";
import AboutUsPageBanner from "components/AboutUsPage/AboutUsPageBanner";
import SubpageHero from "components/utils/SubpageHero";
import { useTranslation } from "react-i18next";
import AboutUsPageList from "components/AboutUsPage/AboutUsPageList";

function AboutUsPage() {
	const { t } = useTranslation();

	return (
		<>
			<Helmet title={ `${t(`aboutUsPage.header.title`)} | Lark-stretch` }/>
			<SubpageHero
				title={ t(`aboutUsPage.header.title`) }
				description={ t(`aboutUsPage.header.description`) }
			/>
			<AboutUsPageContent/>
			<AboutUsPageBanner/>
			<AboutUsPageList/>
		</>
	);
}

export default AboutUsPage;